import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/shared/guards/auth.guard';
import { AdminGuard } from '../shared/guards/admin.guard';
import { ReadOnlyGuard } from '../shared/guards/read-only.guard';
import { SystemAdminGuard } from '../shared/guards/system-admin.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  // {
  //   path: 'home',
  //   loadChildren: () =>
  //     import('./modules/home/home.module').then((m) => m.HomeModule),
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'operator',
    loadChildren: () =>
      import('./modules/operator/operator.module').then((m) => m.OperatorModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'street',
    loadChildren: () =>
      import('./modules/street/street.module').then((m) => m.StreetModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'parking-zone',
    loadChildren: () =>
      import('./modules/parking-zone/parking-zone.module').then((m) => m.ParkingZoneModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'apartment-complex',
    loadChildren: () =>
      import('./modules/apartment-complex/apartment-complex.module').then((m) => m.ApartmentComplexModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'job',
    loadChildren: () =>
      import('./modules/job/job.module').then((m) => m.JobModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'parking-lot',
    loadChildren: () =>
      import('./modules/parking-lot/parking-lot.module').then((m) => m.ParkingLotModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'supportive-document',
    loadChildren: () =>
      import('./modules/supportive-document/supportive-document.module').then((m) => m.SupportiveDocumentModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'document-category',
    loadChildren: () =>
      import('./modules/document-category/document-category.module').then((m) => m.DocumentCategoryModule),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'document',
    loadChildren: () =>
      import('./modules/document/document.module').then((m) => m.DocumentModule),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'subscription',
    loadChildren: () =>
      import('./modules/subscription/subscription.module').then((m) => m.SubscriptionModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'subscription-campaign',
    loadChildren: () =>
      import('./modules/subscription-campaign/subscription-campaign.module').then((m) => m.SubscriptionCampaignModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'user-subscription-request',
    loadChildren: () =>
      import('./modules/user-subscription-request/user-subscription-request.module').then((m) => m.UserSubscriptionRequestModule),
    canActivate: [AuthGuard, ReadOnlyGuard],
  },
  {
    path: 'user-subscription',
    loadChildren: () =>
      import('./modules/user-subscription/user-subscription.module').then((m) => m.UserSubscriptionModule),
    canActivate: [AuthGuard, ReadOnlyGuard],
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./modules/user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuard, ReadOnlyGuard],
  },
  {
    path: 'blog-category',
    loadChildren: () =>
      import('./modules/blog-category/blog-category.module').then((m) => m.BlogCategoryModule),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'blog-article',
    loadChildren: () =>
      import('./modules/blog-article/blog-article.module').then((m) => m.BlogArticleModule),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'badge',
    loadChildren: () =>
      import('./modules/badge/badge.module').then((m) => m.BadgeModule),
    canActivate: [AuthGuard, ReadOnlyGuard],
  },
  {
    path: 'request-payment',
    loadChildren: () =>
      import('./modules/request-payment/request-payment.module').then((m) => m.RequestPaymentModule),
    canActivate: [AuthGuard, ReadOnlyGuard],
  },
  {
    path: 'setting',
    loadChildren: () =>
      import('./modules/setting/setting.module').then((m) => m.SettingModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'subscription-renewal-email-test',
    loadChildren: () =>
      import('./modules/subscription-renewal-email-test/subscription-renewal-email-test.module').then((m) => m.SubscriptionRenewalEmailTestModule),
    canActivate: [AuthGuard, SystemAdminGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard, ReadOnlyGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
    }),
  ],
  providers: [
    AuthGuard,
    SystemAdminGuard,
    AdminGuard,
    ReadOnlyGuard,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
